import React from 'react';
import FormSteps from '../FormSteps';

/**
 * PhotoStep Component
 *
 * Step for uploading user's profile photo
 *
 * @param {Object} formik - Formik instance with form state and methods
 * @param {Function} goToNextStep - Function to navigate to the next step
 * @param {Function} skipStep - Function to skip to the next step
 * @param {Component} UserAvatar - The avatar upload component
 * @param {String} avatar - User's current avatar
 */
const PhotoStep = ({
  formik,
  goToNextStep,
  skipStep,
  UserAvatar,
  avatar
}) => {
  const handleNext = () => {
    goToNextStep();
  };

  return (
    <FormSteps
      header="Add a profile photo"
      description="A friendly photo helps you helps others connect with you."
      nextButton={handleNext}
      skipButton={skipStep}
      nextButtonText="Next"
    >
      <div className="has-text-centered mb-4">
        <UserAvatar avatar={avatar} />
      </div>
    </FormSteps>
  );
};

export default PhotoStep;
